import { render, staticRenderFns } from "./vessel.vue?vue&type=template&id=adddba0e&"
import script from "./vessel.vue?vue&type=script&lang=js&"
export * from "./vessel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports